import { useState } from "react";
import { RegisterClientDTO } from "../../models/user/user.request";
import { useNotification } from "../toster-notification/NotificationContext";
import Loader from "../shared/Loader";
import { validateEmail, validatePassword, validatePhoneNumber } from "../../utils/validators";
import { userService } from "../../services/userService";
import { Form, useNavigate } from "react-router-dom";
import { handleErrorNotification } from "../../utils/errorNotificatioMessage";
import { authService } from "../../services/authService";



const RegisterPage: React.FC = () => {

    const [registerData, setRegisterData] = useState<RegisterClientDTO>({
        fullName: "",
        email: "",
        password: "",
        phoneNumber: "",
        imageUrl: "",
        birthDate: undefined
    });

    const [imageFile, setImageFile] = useState<File | null>(null);
    const [repeatedPassword, setRepeatedPassword] = useState<string>("");
    const [privacyPolicyChecked, setPrivacyPolicyChecked] = useState<boolean>(false);

    const [nameError, setNameError] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");
    const [phoneError, setPhoneError] = useState<string>("");
    const [imageError, setImageError] = useState<string>("");
    const [passwordError, setPasswordError] = useState<string>("");
    const [confirmPasswordError, setConfirmPasswordError] = useState<string>("");
    const [privacyPolicyError, setPrivacyPolicyError] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    const navigate = useNavigate();

    const handleRegister = async (e: React.FormEvent) => {
        e.preventDefault();

        setNameError("");
        setEmailError("");
        setPhoneError("");
        setImageError("");
        setPasswordError("");
        setConfirmPasswordError("");
        setPrivacyPolicyError("");

        let isValid = true;

        if (registerData.fullName.trim() === "") {
            setNameError("Ime i prezime su obavezni.");
            isValid = false;
        }

        let validate = validateEmail(registerData.email);
        if (validate) {
            setEmailError(validate);
            isValid = false;
        }

        validate = validatePhoneNumber(registerData.phoneNumber);
        if (validate) {
            setPhoneError(validate);
            isValid = false;
        }

        validate = validatePassword(registerData.password);
        if (validate) {
            setPasswordError(validate);
            isValid = false;
        }

        if (registerData.password !== repeatedPassword) {
            setConfirmPasswordError("Lozinke se ne poklapaju.");
            isValid = false;
        }

        if (!privacyPolicyChecked) {
            setPrivacyPolicyError("Morate se složiti sa politikom privatnosti.");
            isValid = false;
        }

        // if(imageFile == null){
        //     setImageError("Slika je obavezna");
        //     isValid = false;
        // }

        if (!isValid) {
            return;
        }

        setLoading(true);

        try {
            const response = await authService.EmailExists(registerData.email);
            if (response.success && response.data === true) {
                setEmailError("Email je već registrovan.");
                return;
            } else {

            }
        } catch (error: any) {
            notify("error", "Greška pri registraciji");
            handleErrorNotification(error, notify);
            return;
        } finally {
            setLoading(false);
        }

        const registerFormData = new FormData();

        registerFormData.append("fullName", registerData.fullName);
        registerFormData.append("email", registerData.email);
        registerFormData.append("phoneNumber", registerData.phoneNumber);
        registerFormData.append("password", registerData.password);

        if (registerData.birthDate) {
            registerFormData.append("birthDate", registerData.birthDate.toString());
        }

        if (imageFile) {
            registerFormData.append("imageFile", imageFile);
        }

        try {
            const response = await userService.registerClient(registerFormData);
            if (response.success) {
                notify("success", "Uspešna registracija", "Uspešno ste se registrovali");
                navigate("/after-register?email=" + encodeURIComponent(registerData.email));
            } else {
                notify("error", "Greška pri registraciji", "Došlo je do greške pri registraciji");
            }
        } catch (error: any) {
            notify("error", "Greška pri registraciji");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    }


    return (
        <>
            <section className="register-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="register-wrapper">
                        <div className="form-block-7 w-form">
                            <div>
                                <div className="text-block-31">
                                    Dobro došli u <span className="text-span-3">QuickMenu</span>
                                </div>
                                <div className="description-text text-center">Popunite formu kako bi ste se registrovali</div>
                            </div>
                            <form className="form-10" onSubmit={handleRegister}>

                                <div className="div-block-41">
                                    <label className="register-label">Ime i prezime *</label>
                                    <input className="register-input w-input" placeholder="Unesite ime i prezime" type="text" autoComplete="name"
                                        value={registerData.fullName}
                                        onChange={e => setRegisterData({ ...registerData, fullName: e.target.value })}
                                    />
                                    <div className="error-text">{nameError}</div>
                                </div>

                                <div className="div-block-41">
                                    <label className="register-label">Email *</label>
                                    <input className="register-input w-input" placeholder="Unesite email" type="email" autoComplete="email"
                                        value={registerData.email}
                                        onChange={e => setRegisterData({ ...registerData, email: e.target.value })}
                                    />
                                    <div className="error-text">{emailError}</div>
                                </div>

                                <div className="div-block-41">
                                    <label className="register-label">Broj telefona *</label>
                                    <input className="register-input w-input" placeholder="Unesite broj telefona" type="tel" autoComplete="tel"
                                        value={registerData.phoneNumber}
                                        onChange={e => setRegisterData({ ...registerData, phoneNumber: e.target.value })}
                                    />
                                    <div className="error-text">{phoneError}</div>
                                </div>

                                <div className="div-block-41">
                                    <label className="register-label">Profilna slika</label>
                                    <input className="register-input w-input" placeholder="Unesite broj telefona" type="file"
                                        onChange={e => {
                                            if (e.target.files && e.target.files.length > 0) {
                                                setImageFile(e.target.files[0]);
                                            }
                                        }}
                                    />
                                    <div className="error-text">{imageError}</div>
                                </div>

                                <div className="div-block-41">
                                    <label className="register-label">Datum rodjenja</label>
                                    <input className="register-input w-input" placeholder="Unesite broj telefona" type="date"
                                        onChange={e => setRegisterData({ ...registerData, birthDate: e.target.value ? new Date(e.target.value) : undefined })}
                                    />
                                </div>

                                <div className="div-block-41">
                                    <label className="register-label">Lozinka *</label>
                                    <input className="register-input w-input" placeholder="Unesite lozinku" type="password" autoComplete="new-password"
                                        value={registerData.password}
                                        onChange={e => setRegisterData({ ...registerData, password: e.target.value })}
                                    />
                                    <div className="error-text">{passwordError}</div>
                                </div>

                                <div className="div-block-41">
                                    <label className="register-label">Ponovljena lozinka *</label>
                                    <input className="register-input w-input" placeholder="Ponovite lozinku" type="password" autoComplete="new-password"
                                        value={repeatedPassword}
                                        onChange={e => setRepeatedPassword(e.target.value)}
                                    />
                                    <div className="error-text">{confirmPasswordError}</div>
                                </div>

                                <div className="div-block-41" style={{ flexDirection: "row", gap: "0.5rem" }}>
                                    <input type="checkbox" required 
                                        checked={privacyPolicyChecked}
                                        onChange={e => setPrivacyPolicyChecked(e.target.checked)}
                                    />
                                    <label className="register-label">Slažem se sa <a href="http://www.quickmenu.rs/privacy-policy">Politikom privatnosti</a>
                                    </label>
                                    <div className="error-text">{privacyPolicyError}</div>
                                </div>

                                {loading ?
                                    (
                                        <Loader size={40} color="#442fec" fullscreen={false} />
                                    ) : (
                                        <input type="submit" data-wait="Please wait..." className="register-button w-button" value="Registruj se" />
                                    )}

                                <div className="description-text text-center">Već imate nalog? <span className="text-span-4" onClick={() => navigate("/login")}>Prijavite se</span></div>

                            </form>
                        </div>
                    </div>
                </div >
            </section >
        </>
    );
};

export default RegisterPage;